<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog">
    <list ref="list" common :showCheckbox="multiple" :show-column="false" :show-other="showOther" :checkbox-fixed="false">
      <template #column>
        <slot name="column" />
        <template v-if="selectable&&!multiple">
          <el-table-column label="操作" align="center" width="60" fixed="right">
            <template slot-scope="{row}">
              <el-button @click="onSelect(row)" type="text">选择</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <template v-if="selectable&&multiple">
          <el-button type="primary" @click="selectMultiple">选择</el-button>
        </template>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "教职人员列表",
    },
    showOther: {
      type: Boolean,
      default: true,
    },
  },
  methods: {},
};
</script>